import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.css'],
})
export class ModalErrorComponent implements OnInit {
  @Input() public icon!: string;
  @Input() public text!: string;
  @Input() public code!: string;
  @Input() public phone!: string;
  @Input() public description!: string;

  constructor(
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { name: string; text: string; description: string; phone: string; code: string }
  ) {
    this.icon = 'error_outline';
  }

  public ngOnInit(): void {
    this.assignValues();
  }

  private assignValues(): void {
    const { code, text, phone, description } = this.data;
    this.text = text;
    this.description = description;
    this.phone = phone;
    this.code = code;
  }
}
